(() => {
  if (window.__roadSpecCartFitmentLoaded) return;
  window.__roadSpecCartFitmentLoaded = true;

  const storageKey = 'roadspec_vehicle_context_v1';
  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const yearNumber = (value) => Number.parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
  const readContext = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      return value && typeof value === 'object' ? value : null;
    } catch (_) { return null; }
  };
  const matchState = (item, context) => {
    if (!context?.year || !context?.make || !context?.model) return 'no-context';
    const start = yearNumber(item.dataset.rspCartYearStart);
    const end = yearNumber(item.dataset.rspCartYearEnd || item.dataset.rspCartYearStart);
    const year = yearNumber(context.year);
    if (!start || !end || !item.dataset.rspCartMake || !item.dataset.rspCartModel) return 'incomplete';
    return year >= start && year <= end && normalize(item.dataset.rspCartMake) === normalize(context.make) && normalize(item.dataset.rspCartModel) === normalize(context.model) ? 'match' : 'review';
  };
  const sync = () => {
    const context = readContext();
    document.querySelectorAll('[data-rsp-cart-fitment-item]').forEach((item) => {
      const state = matchState(item, context);
      const target = item.querySelector('[data-rsp-cart-fitment-state]');
      item.dataset.rspCartFitmentState = state;
      item.classList.toggle('rsp-cart-fitment--match', state === 'match');
      item.classList.toggle('rsp-cart-fitment--review', state !== 'match');
      if (!target) return;
      const nextText = state === 'match' ? 'Catalog application matches your saved vehicle' : state === 'no-context' ? 'Set a vehicle to compare' : state === 'incomplete' ? 'Listing fitment data is incomplete' : 'Saved vehicle differs — review carefully';
      if (target.textContent !== nextText) target.textContent = nextText;
    });
    document.querySelectorAll('[data-rsp-cart-confirmation]').forEach((root) => {
      const checkbox = root.querySelector('[data-rsp-fitment-confirmation]');
      const status = root.querySelector('[data-rsp-cart-confirmation-status]');
      if (!checkbox || !status) return;
      const nextStatus = checkbox.checked ? 'Fitment review recorded for this checkout.' : 'Review the application, reference number and photos before checkout. You can continue without checking this box.';
      if (checkbox.checked) {
        root.classList.remove('is-invalid');
        if (status.textContent !== nextStatus) status.textContent = nextStatus;
      } else if (!root.classList.contains('is-invalid') && status.textContent !== nextStatus) {
        status.textContent = nextStatus;
      }
    });
  };
  const showOptionalReminder = (checkout) => {
    const targetId = checkout?.dataset.rspConfirmationTarget;
    const root = targetId ? document.getElementById(targetId) : checkout?.closest('[data-rsp-cart-confirmation]');
    const checkbox = root?.querySelector('[data-rsp-fitment-confirmation]');
    if (!root || !checkbox || checkbox.checked) return;
    root.classList.remove('is-invalid');
    const status = root.querySelector('[data-rsp-cart-confirmation-status]');
    if (status) status.textContent = 'You can continue to secure checkout. Review the identifiers and photos first, or ask us a question.';
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-rsp-fitment-confirmation]')) {
      event.target.closest('[data-rsp-cart-confirmation]')?.classList.toggle('is-confirmed', event.target.checked);
      sync();
    }
  });
  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-rsp-checkout]');
    if (checkout) showOptionalReminder(checkout);
  });
  document.addEventListener('submit', (event) => {
    const checkout = event.submitter?.matches('[data-rsp-checkout]') ? event.submitter : null;
    if (checkout) showOptionalReminder(checkout);
  }, true);
  window.addEventListener('roadspec:vehicle-context-updated', sync);
  new MutationObserver(() => sync()).observe(document.body, { childList: true, subtree: true });
  sync();
})();
